import { useMutation } from '@tanstack/react-query';

import { ImageApi } from '@/api/domains/image.api';

export const useUploadImage = () =>
  useMutation({
    mutationFn: ImageApi.uploadImage,
  });
